import {
  createCatalogEndpoint,
  createCrudEndpoints,
  createExportEndpoint,
} from '@/core/utils'
import { TLog } from '.'
import {
  DataWithPagination,
  TBaseCatalogs,
  TFilters,
  UpdatePayload,
} from '@/core/types'
import api from '@/core/config/axios'
import { AxiosRequestConfig } from 'axios'
import { TArticle } from '../purchase-orders'
import { toValue } from 'vue'
import { TMill } from '../mills'

export type TLogs = DataWithPagination<TLog>

export const serviceConfig = {
  model: 'log-reports/details',
  version: 'v1',
  scrap: {
    model: 'scrap',
    version: 'v1',
  },
  catalogs: {
    articles: {
      model: 'articles',
      version: 'v1',
    },
    categories: {
      model: undefined,
      version: 'v1',
    },
    mills: {
      model: 'mills',
      version: 'v1',
    },
  },
}
const { articles, categories, mills } = serviceConfig.catalogs

const moduleServiceHandlers = {
  ...createCrudEndpoints<TLogs, TLog>(
    serviceConfig.model,
    serviceConfig.version,
  ),
  loadRecords: async (params: TFilters): Promise<TLogs> => {
    const urlSearchParams = [
      `page=${toValue(params.page) ?? 1}`,
      toValue(params.dynamicFilters ?? ''),
    ]
      .filter(Boolean)
      .join('&')

    return api
      .get(
        `${serviceConfig.version ?? ''}/${serviceConfig.model}/${
          serviceConfig.scrap.model
        }?${urlSearchParams}`,
      )
      .then((response) => response.data)
  },
  editRecord: async (
    payload: TLog & UpdatePayload,
    id?: number,
    config?: AxiosRequestConfig<TLog & UpdatePayload>,
  ): Promise<TLog> =>
    await api
      .put(
        `${serviceConfig.version ?? ''}/${serviceConfig.model}/${id}/${
          serviceConfig.scrap.model
        }`,
        payload,
        config,
      )
      .then((response) => response.data),
}

const articlesCatalog = createCatalogEndpoint<TArticle[]>(
  articles.model,
  articles.version,
)

const millsCatalog = createCatalogEndpoint<TMill[]>(mills.model, mills.version)

const categoriesCatalog = createCatalogEndpoint<TBaseCatalogs>(
  categories.model,
  categories.version,
)

const moduleExportHandler = createExportEndpoint(serviceConfig.model)
const catalogServiceHandlers = {
  articlesCatalog,
  categoriesCatalog,
  millsCatalog,
}

export { moduleServiceHandlers, moduleExportHandler, catalogServiceHandlers }
